/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMessages} from '../api'

 export const useQueryGetMessages = createReactQueryHook('getMessages', getMessages)
